@if (state.roundState.phase === AppPhase.TableClosed && state.worker?.accessLevel !== WorkerAccessLevel.Supervisor) {
    <app-supervisor-panel [message]="'Scan supervisor card to open table'" [showBackButton]="false" />
} @else if (state.supervisorState) {
    @switch (state.supervisorState.subPhase) {
        @case (SupervisorSubPhase.WaitingForSupervisor) {
            @if (state.worker?.accessLevel !== WorkerAccessLevel.Supervisor) {
                <app-supervisor-panel
                    [inverseColors]="true"
                    [message]="'Scan supervisor card to continue'"
                    (backClicked)="cancelActionClicked.emit()"
                />
            }
        }

        @case (SupervisorSubPhase.ConfirmAction) {
            @switch (state.supervisorState.selectedAction) {
                @case (SupervisorAction.ContinueGame) {
                    <app-supervisor-panel
                        [title]="'Continuing game'"
                        [message]="'Scan supervisor card to continue game'"
                        (backClicked)="cancelActionClicked.emit()"
                    />
                }

                @case (SupervisorAction.VoidGame) {
                    <app-supervisor-panel
                        [title]="'Voiding game and change shoe'"
                        [message]="'Scan supervisor card to confirm changes and continue'"
                        (backClicked)="cancelActionClicked.emit()"
                    />
                }

                @case (SupervisorAction.FreeHand) {
                    <app-supervisor-panel
                        [title]="'Freeing hand'"
                        [message]="'Scan supervisor card to confirm'"
                        (backClicked)="cancelActionClicked.emit()"
                    />
                }

                @case (SupervisorAction.ChangeResult) {
                    @if (state.supervisorState.changedGameResult) {
                        <app-supervisor-panel
                            [title]="'Result changed'"
                            [message]="'Scan supervisor card to confirm changes and continue'"
                            (backClicked)="cancelActionClicked.emit()"
                        />
                    }
                }

                @case (SupervisorAction.CloseTable) {
                    <app-supervisor-panel
                        [title]="'Closing ' + (state.configuration.gameType | gameLabel)"
                        [message]="'Scan supervisor card to confirm changes and continue'"
                        (backClicked)="cancelActionClicked.emit()"
                    />
                }
            }
        }

        @case (SupervisorSubPhase.ConfirmGameSelection) {
            <app-supervisor-panel
                [title]="'Selected game: ' + (state.supervisorState.selectedGameType | gameLabel)"
                [message]="'Scan supervisor card to confirm the selection and continue'"
                (backClicked)="cancelActionClicked.emit()"
            />
        }
    }
}
